<div matDialogTitle>Skrivguide</div>
<mat-dialog-content>
  <div class="guide">
    <div class="lead-text">
      <p>Här kommer du att följa ett flöde för att få hjälp med din motiveringstext.</p>
      <p>Notera att detta endast är en hjälp, och att du själv måste färdigställa motiveringen med att komplettera
        motiveringstexten där det markeras.</p>
      <p>Skrivhjälpen kommer endast bidra med hjälptext på en låntagare (person 1). Inkluderar kalkylen flera låntagare
        behöver medlåntagare (person 2, person 3 ex) noteras manuellt i motiveringstexten.</p>
      <p>Definition för helkund = ” Att vara helkund på Sparbanken Syd innebär att du samlar alla dina ekonomiska
        produkter & tjänster – lönekonto, sparande, lån, kort (och försäkringar) hos oss”.</p>
      <p>Definition för delkund = ”Att vara delkund på Sparbanken Syd innebär att du har ett fåtal eller några av våra
        produkter och tjänster, men att vi har möjlighet att erbjuda och teckna fler produkter hos oss”.</p>
      <p>Ny kund = Kund utan befintligt bankengagemang hos oss.</p>
      <p>Befintlig kund = Befintlig kund med aktivt bankengagemang hos oss.</p>
    </div>
    <h4>Välj Kundtyp</h4>
    <mat-chip-listbox [(ngModel)]="customerType">
      <mat-chip-option [value]="0">Ny helkund</mat-chip-option>
      <mat-chip-option [value]="1">Ny delkund</mat-chip-option>
      <mat-chip-option [value]="2">Befintlig helkund</mat-chip-option>
      <mat-chip-option [value]="3">Befintlig delkund</mat-chip-option>
    </mat-chip-listbox>
    @if (customerType() === 0) {
      <spb-text-item type="newFull"/>
    }
    @if (customerType() === 1) {
      <spb-text-item type="newPart"/>
    }
    @if (customerType() === 2) {
      <spb-text-item type="currentFull"/>
    }
    @if (customerType() === 3) {
      <spb-text-item type="currentPart"/>
    }
  </div>
  @if (customerType() !== null) {
    <h4>Anledning till lönsamhetskalkyl, välj en eller flera</h4>
    <mat-chip-listbox [(ngModel)]="reason" multiple>
      <mat-chip-option [value]="0">Nytt bolån</mat-chip-option>
      <mat-chip-option [value]="1">Ny Omsättning av lån</mat-chip-option>
      <mat-chip-option [value]="2">Priserbjudande från annan bank</mat-chip-option>
      <mat-chip-option [value]="3">Förfrågan om amorteringsunderlag</mat-chip-option>
    </mat-chip-listbox>

    @if (reason()?.includes(0)) {
      <spb-text-item type="newLoan"/>

    }
    @if (reason()?.includes(1)) {
      <spb-text-item type="renewal"/>

    }
    @if (reason()?.includes(2)) {
      <spb-text-item type="offer"/>
    }
    @if (reason()?.includes(3)) {
      <spb-text-item type="amortizationBase"/>

    }

    @if (reason() !== null && reason()!.length > 0) {
      <h4>Kompletterande information om kunden som underbygger motivering till prissättning (välj en eller flera)</h4>
      <mat-chip-listbox multiple [(ngModel)]="comp">
        <mat-chip-option [value]="0">Bundna lån idag</mat-chip-option>
        <mat-chip-option [value]="1">Kund med sparkapital</mat-chip-option>
        <mat-chip-option [value]="2">Private banking</mat-chip-option>
        <mat-chip-option [value]="3">Företagskoppling</mat-chip-option>
        <mat-chip-option [value]="4">Samarbetspartners</mat-chip-option>
        <mat-chip-option [value]="5">Viktig koppling</mat-chip-option>
        <mat-chip-option [value]="6">Hög potential</mat-chip-option>
      </mat-chip-listbox>
      @if (comp()?.includes(0)) {
        <spb-text-item type="custBoundLoan"/>
      }
      @if (comp()?.includes(1)) {
        <spb-text-item type="custSavings"/>
      }
      @if (comp()?.includes(2)) {
        <spb-text-item type="custPrivateBanking"/>
      }
      @if (comp()?.includes(3)) {
        <spb-text-item type="custCorp"/>
      }
      @if (comp()?.includes(4)) {
        <spb-text-item type="custPartner"/>
      }
      @if (comp()?.includes(5)) {
        <spb-text-item type="custImportant"/>
      }
      @if (comp()?.includes(6)) {
        <spb-text-item type="custPotential"/>
      }
    }

    <h4>Rådgivarens affärsmässiga ställningstagande till prissättningen</h4>

    @if (comp() !== null && comp()!.length > 0) {
      <mat-chip-listbox [(ngModel)]="statement">
        <mat-chip-option [value]="0">Eget mandat</mat-chip-option>
        <mat-chip-option [value]="1">Tillstyrkan annans mandat</mat-chip-option>
      </mat-chip-listbox>
    }
    @if (statement() !== null) {
      @if (statement() === 0) {
        <spb-text-item type="decisionOwn"/>
      }
      @if (statement() === 1) {
        <spb-text-item type="decisionOther"/>
      }
    }
  }
  @if (textsCombined()) {
    <h4>Text att tillföra motiveringen</h4>
    <p>Redigera de enskilda delarna ovan. Du kan redigera i hela texten efter du stängt guiden.</p>
    <div class="end-note"> {{ textsCombined() }}</div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matDialogClose matButton="outlined">Avbryt</button>
  <button matButton="filled"
          (click)="profit.motivation.set(textsCombined())"
          matDialogClose>Spara
  </button>
</mat-dialog-actions>
